module.exports = __webpack_public_path__ + "img/triangle_opaque_exclamation.8e9820e1.svg";